module.exports = __webpack_public_path__ + "img/kusa03.2aabb3ea.png";